import React from 'react';
import { Box, BoxProps } from '@mui/material';

const typeStyles = {
  icon: {
    gridColumn: 'icon-start / icon-end',
    justifySelf: 'center',
    '& svg': { display: 'block' },
  },
  text: {
    alignSelf: 'center',
    gridColumn: 'text-start / text-end',
    '&:last-child': {
      // If no actions element, take over that cell
      gridColumn: 'text-start / end',
    },
  },
  actions: {
    alignSelf: 'center',
    gridColumn: 'actions-start / actions-end',
  },
  withHeader: {
    alignSelf: 'start',
    gridColumn: 'actions-start / actions-end',
  },
};

interface Props extends BoxProps {
  type: 'icon' | 'text' | 'actions' | 'withHeader';
}

const IconRowCell: React.FC<Props> = (props: Props) => {
  const {
    type, children, className, sx, ...otherProps
  } = props;

  return (
    <Box
      className={className}
      sx={sx !== undefined ? [typeStyles[type], ...(Array.isArray(sx) ? sx : [sx])] : typeStyles[type]}
      {...otherProps}
    >
      {children}
    </Box>
  );
};

export default IconRowCell;
